import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { focusRingClassName } from '@digiwedge/ui-headless';
import { Button as TeeTimeButton } from '../Buttons/Button.js';
export const TextInput = ({ type = 'text', placeholder, value, onChange, onClear, leftIcon, showClearButton = true, rightAdornment, className = '', inputProps, }) => {
    const handleClear = () => {
        if (onClear) {
            onClear();
        }
        else {
            onChange('');
        }
    };
    const { className: inputClassName, ...restInputProps } = inputProps ?? {};
    const hasRightAdornment = Boolean(rightAdornment);
    const hasClearButton = Boolean(value) && showClearButton && !hasRightAdornment;
    const paddingRightClass = hasRightAdornment || hasClearButton ? 'pr-10' : 'pr-4';
    const classes = [
        `w-full h-10 ${leftIcon ? 'pl-10' : 'pl-3'} ${paddingRightClass} border border-primary rounded-md text-sm transition-all duration-[var(--animation-duration,150ms)] ${focusRingClassName} focus-visible:border-transparent`,
        className,
        inputClassName,
    ]
        .filter(Boolean)
        .join(' ');
    return (_jsxs("div", { className: "relative", children: [_jsx("input", { type: type, placeholder: placeholder, value: value, onChange: (e) => onChange(e.target.value), className: classes, ...restInputProps }), leftIcon && (_jsx("div", { className: "absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-primary", children: leftIcon })), hasRightAdornment && (_jsx("div", { className: "absolute right-3 top-1/2 -translate-y-1/2", children: rightAdornment })), hasClearButton && (_jsx(TeeTimeButton, { variant: "text", onClick: handleClear, className: "absolute right-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400 hover:text-gray-600", children: "\u00D7" }))] }));
};
//# sourceMappingURL=TextInput.js.map